import { useState } from 'react'
import { TableFilter } from '../CarDetailTables/TableFilter'
import { CarDetailTables } from '../CarDetailTables/CarDetailTables'

export function CarInfoTable({ id }) {
  const [filter, setFilter] = useState('fuel')
  const currentYear = new Date().getFullYear()

  const isProd = window.location.hostname.includes('kunde.autoplan.no')

  const startDate = new Date()
  if (isProd) {
    startDate.setFullYear(currentYear - 1)
  } else {
    startDate.setFullYear(currentYear - 2)
  }
  const [fromDate, setFromDate] = useState(startDate)
  const [toDate, setToDate] = useState(new Date())

  return (
    <div className="flex-col pt-8 flex w-full gap-8">
      <TableFilter
        setFilter={setFilter}
        filter={filter}
        fromDate={fromDate}
        toDate={toDate}
        setFromDate={setFromDate}
        setToDate={setToDate}
      />
      <CarDetailTables id={id} fromDate={fromDate} toDate={toDate} filter={filter} />
    </div>
  )
}
